// @flow

import { useCallback } from 'react';

import { type UserInputName } from '../user-input';
import { useUserInputValue } from './use-user-input-value';


type Value = string;
type SelectEvent = SyntheticInputEvent<HTMLSelectElement>;
type HandleChange = (event: SelectEvent) => void;

export function useUserInputAsSelect(name: UserInputName): [Value, HandleChange] {
  const [value, setValue] = useUserInputValue(name);

  const handleChange = useCallback((event: SelectEvent) => {
    setValue(event.target.value);
  }, [setValue]);

  return [value, handleChange];
}
